(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/player-registration/assets/react/components/svs-logo.js') >= 0) return;  svs.modules.push('/modules/player-registration/assets/react/components/svs-logo.js');

'use strict';

const Brand = svs.ui.ReactBrand;
const SvsLogo = _ref => {
  let {
    isNegative
  } = _ref;
  return React.createElement("div", null, React.createElement(Brand, {
    brand: "svenskaspel-twolines".concat(isNegative ? '-neg' : ''),
    emblem: true
  }));
};
svs.playerRegistration.components.SvsLogo = SvsLogo;

 })(window);